import { createSlice } from "@reduxjs/toolkit";

export const toggleThemeSlice = createSlice({
  name: "toggleTheme",
  initialState: {
    toggleTheme: localStorage.getItem("theme")? JSON.parse(localStorage.getItem("theme")):false,
  },

  reducers: {
    toggler: (state,action) => {
      state.toggleTheme = action.payload.value;
      localStorage.setItem("theme",JSON.stringify(state.toggleTheme))
    }
  },
});

export const { toggler } = toggleThemeSlice.actions;

export const selecttoggleTheme = (state) =>  state.toggleTheme.toggleTheme;

export default toggleThemeSlice.reducer;
